import {Select} from "antd";
import {uploadFile} from "../Utils";
import {gql, useMutation} from "@apollo/client";

export const SelectUpload = (props) => {
    const [insert_attachment, {insert_attachment_error}] = useMutation(gql`mutation MyMutation($objects: [attachment_insert_input!] = {}) {
        insert_attachment(objects: $objects) {
            returning {
                id
            }
        }
    }
    `);
    const nameList = [...(props.nameList || [])]
    const item = (props.item || '')
    const description = (props.description || null)
    return <>
        <Select
            style={{
                width: '100%',
            }}
            showSearch
            placeholder="选择上传类型"
            optionFilterProp="children"
            onChange={(text) => {
                uploadFile().then((theFile) => {
                    insert_attachment({
                        variables: {
                            objects: [{
                                item,
                                name: theFile.name,
                                path: theFile.fileName,
                                text,
                                description
                            }]
                        }
                    })
                })
            }}
            // onSearch={onSearch}
            filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={nameList.map(name => {
                return {
                    value: name,
                    label: name,
                }
            })}
            value={"选择上传文件类型"}
        />
    </>
}
